import React, { useEffect, useState } from "react";
import TopBar from "./TopBar";
import NavBar from "./NavBar";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 w-full bg-white transition-shadow ${scrolled ? "shadow-[0_4px_20px_rgba(0,0,0,0.06)]" : ""}`}
    >
      <TopBar />
      <NavBar />
    </header>
  );
}
